var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.loaderClass},[(_vm.isProcessing)?_c('common-logo-spinner',{attrs:{"width":_vm.width,"color":_vm.color}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }